import { render, staticRenderFns } from "./GrAlertBox.vue?vue&type=template&id=5cac106f&scoped=true&"
import script from "./GrAlertBox.vue?vue&type=script&lang=ts&"
export * from "./GrAlertBox.vue?vue&type=script&lang=ts&"
import style0 from "./GrAlertBox.vue?vue&type=style&index=0&id=5cac106f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac106f",
  null
  
)

/* custom blocks */
import block0 from "./GrAlertBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
